var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fade-transition',{attrs:{"duration":1000,"mode":"out-in"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }